<div class="coffee-content-container">
  <div class="coffee-container-overlay"></div>
  <div class="container coffee-container">
    <div class="row" *ngIf="!isCoffeeCodeUsed && isSuccess && !errorMessage">
      <div class="col-sm-12 text-center">
        <h3 class="coffee-code-text">Please, show this code to barista: </h3>
        <h2 class="coffee-code-text">{{ coffeeCode.code }}</h2>
      </div>
    </div>
    <div class="row" *ngIf="isCoffeeCodeUsed">
      <div class="col-sm-12">
        Thanks. We will make you a coffee right now.
      </div>
    </div>
    <div class="row" *ngIf="errorMessage && isSuccess == false">
      <div class="col-sm-12">
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      </div>
    </div>
<!--    <div class="buttons-block text-center">-->
<!--      <button type="button" class="btn btn-default" (click)="returnToProfile()">Return</button>-->
<!--    </div>-->
  </div>
</div>
